import React from 'react'
import Image from 'next/image'
import { Center } from '@/src/views/parts/bases/Center'

export type Props = {}

export const Layout = (_props: Props) => {
  return (
    <Center className="h-full w-full p-8">
      <Center className="h-full w-full rounded-2xl border border-[#805BE7]  bg-black">
        <Image
          src={require('@/public/images/iconComingsoon.png')}
          objectFit="contain"
          height={180}
          width={180}
          alt="Coming Soon"
        />
      </Center>
    </Center>
  )
}
